/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AcceptPatientTreatmentResponseDto
 */
export interface AcceptPatientTreatmentResponseDto {
    /**
     * Status of the acceptance operation
     * @type {string}
     * @memberof AcceptPatientTreatmentResponseDto
     */
    status: AcceptPatientTreatmentResponseDtoStatusEnum;
    /**
     * Status message
     * @type {string}
     * @memberof AcceptPatientTreatmentResponseDto
     */
    message: string;
}


/**
 * @export
 */
export const AcceptPatientTreatmentResponseDtoStatusEnum = {
    NotFound: 'not_found',
    AcceptedSuccessfully: 'accepted_successfully',
    AlreadyAccepted: 'already_accepted'
} as const;
export type AcceptPatientTreatmentResponseDtoStatusEnum = typeof AcceptPatientTreatmentResponseDtoStatusEnum[keyof typeof AcceptPatientTreatmentResponseDtoStatusEnum];


/**
 * Check if a given object implements the AcceptPatientTreatmentResponseDto interface.
 */
export function instanceOfAcceptPatientTreatmentResponseDto(value: object): value is AcceptPatientTreatmentResponseDto {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function AcceptPatientTreatmentResponseDtoFromJSON(json: any): AcceptPatientTreatmentResponseDto {
    return AcceptPatientTreatmentResponseDtoFromJSONTyped(json, false);
}

export function AcceptPatientTreatmentResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcceptPatientTreatmentResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
    };
}

export function AcceptPatientTreatmentResponseDtoToJSON(json: any): AcceptPatientTreatmentResponseDto {
    return AcceptPatientTreatmentResponseDtoToJSONTyped(json, false);
}

export function AcceptPatientTreatmentResponseDtoToJSONTyped(value?: AcceptPatientTreatmentResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': value['status'],
        'message': value['message'],
    };
}

